<template>
  <section class="drawer">
    <!-- 로그인 후 -->
    <aside class="mdc-drawer mdc-drawer--modal">
      <div>
        <div class="pda-default">
          <div :style="memberImageUrl
              ? `background-image: url(${memberImageUrl});`
              : `background-image: url('images/avatar_image.png');`
            " @click="openPattenDialog" class="drawer-profile-logo"></div>
          <img src="/images/profile_setting.png" alt="Setting" class="profile_setting" />
        </div>
        <div class="mdc-drawer__header mgt-5">
          <div class="d-flex">
            <div class="t-headline7 d-inline-block name-line-height t-color-title">
              {{ memberName }}
              <ProfileTier v-if="
                memberData.tier &&
                memberData.tier.image &&
                memberData.tier.image.resourceUri
              " :data="memberData"
                :className="'size-18 position-relative mgl-5 right-0 bottom-2 d-inline-block vertical-align-middle'" />
            </div>
          </div>
          <ProfileTierName :data="memberData" v-if="memberData && memberData.tier" :className="'mgt-8'" />
          <div class="mgt-8">
            <div>
              <span class="t-body4">{{ memberDutyRoleName }}</span>
              <br />
              <span class="t-body4">{{ memberResponsibilityName }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="mdc-drawer__content">
        <nav class="mdc-list">
          <hr class="mdc-list-divider" />

          <!-- 홈 -->
          <router-link class="mdc-list-item" to="/main" @click.native="activeInactive('main')" style="color: #212121"
            tabindex="0" :class="{ 'mdc-list-item__active': getCurrentRoute('/main') }">
            <span class="drawer-icon-size material-icons mdc-list-item__graphic">
              <span class="material-icons navi-icons" :class="{
                'mdc-list-item__active_icon': getCurrentRoute('/main'),
              }">home</span>
            </span>
            {{ $t("S10035") }}
          </router-link>

          <hr class="mdc-list-divider" />

          <div v-for="(group, index) in categoryGroup" :key="group.id">
            <!-- 컨텐츠 - 드로어 -->
            <drawer-content v-if="index === 0" @closeDrawer="closeDrawer" @handleCategory="handleCategory"
              :openCategory="openCategory" :group="group"></drawer-content>

            <!-- 이러닝 - 드로어 -->
            <drawer-e-learning v-if="index === 1" :group="group" @closeDrawer="closeDrawer"
              @handleCategory="handleCategory" :openCategory="openCategory"></drawer-e-learning>

            <hr v-if="index === 0 || index === 1" class="mdc-list-divider" />
          </div>

          <!-- 공지사항 -->
          <router-link v-if="noticeBoardData" class="mdc-list-item" :to="`/notice?bId=${noticeBoardData ? noticeBoardData.identifier : ''
            }&id=${noticeBoardData ? noticeBoardData.noticeId : ''}`" @click.native="activeInactive('notice')"
            style="color: #212121" :class="[
              routeName[0] === 'notice' ? 'mdc-list-item--activated' : '',
              { 'mdc-list-item__active': getCurrentRoute('/notice') },
            ]" aria-current="page">
            <span class="drawer-icon-size material-icons mdc-list-item__graphic">
              <span class="material-icons-outlined navi-icons" :class="{
                'mdc-list-item__active_icon': getCurrentRoute('/notice'),
              }">campaign</span>
            </span>
            {{
              noticeBoardData && noticeBoardData.name
                ? noticeBoardData.name
                : "Notice"
            }}
          </router-link>

          <hr v-if="noticeBoardData" class="mdc-list-divider" />

          <!-- 소셜러닝 - 포럼 -->
          <router-link v-if="forumData" class="mdc-list-item" :to="socialLearningRouterLink()"
            @click.native="activeInactive('group')" style="color: #212121" :class="[
              routeName[0] === 'socialLearning'
                ? 'mdc-list-item--activated'
                : '',
              { 'mdc-list-item__active': getCurrentRoute('/socialLearning') },
            ]" aria-current="page">
            <span class="drawer-icon-size material-icons mdc-list-item__graphic">
              <span class="material-icons navi-icons" :class="{
                'mdc-list-item__active_icon':
                  getCurrentRoute('/socialLearning'),
              }">group</span>
            </span>
            {{ $t("S10028") }}
          </router-link>

          <hr v-if="forumData" class="mdc-list-divider" />

          <!-- 이벤트 -->
          <router-link v-if="!noEvent" class="mdc-list-item" :class="[
            routeName[0] === 'event' ? 'mdc-list-item--activated' : '',
            { 'mdc-list-item__active': getCurrentRoute('/event') },
          ]" to="/event" @click.native="activeInactive('event')" aria-current="page">
            <span class="drawer-icon-size material-icons mdc-list-item__graphic">
              <span class="material-icons navi-icons" :class="{
                'mdc-list-item__active_icon': getCurrentRoute('/event'),
              }">redeem</span>
            </span>
            <p v-if="this.newEvent" data-letters="N" />
            {{ $t("S10029") }}
          </router-link>

          <hr v-if="!noEvent" class="mdc-list-divider" />

          <!-- 시험 -->
          <router-link class="mdc-list-item" :class="[
            routeName[1] === 'exam' ? 'mdc-list-item--activated' : '',
            { 'mdc-list-item__active': getCurrentRoute('/independent/exam') },
          ]" to="/independent/exam" @click.native="activeInactive('test')" aria-current="page">
            <span class="drawer-icon-size material-icons mdc-list-item__graphic">
              <span class="material-icons-outlined navi-icons" :class="{
                'mdc-list-item__active_icon':
                  getCurrentRoute('/independent/exam'),
              }">edit_document</span>
            </span>
            <p v-if="this.newExam" data-letters="N" />

            {{ $t("S10030") }}
          </router-link>

          <hr class="mdc-list-divider" />

          <!-- 체크리스트 -->
          <router-link class="mdc-list-item" :class="[
            routeName[1] === 'checklist' ? 'mdc-list-item--activated' : '',
            {
              'mdc-list-item__active': getCurrentRoute('/checklist'),
            },
          ]" to="/checklist" @click.native="activeInactive('checklist')" aria-current="page">
            <span class="drawer-icon-size material-icons mdc-list-item__graphic">
              <span class="material-icons-outlined navi-icons" :class="{
                'mdc-list-item__active_icon': getCurrentRoute('/checklist'),
              }">store</span>
            </span>
            {{ $t("2070") }}
          </router-link>

          <hr class="mdc-list-divider" />

          <!-- 설문조사 -->
          <router-link class="mdc-list-item" :class="[
            routeName[1] === 'survey' ? 'mdc-list-item--activated' : '',
            {
              'mdc-list-item__active': getCurrentRoute('/independent/survey'),
            },
          ]" to="/independent/survey" @click.native="activeInactive('survey')" aria-current="page">
            <span class="drawer-icon-size material-icons mdc-list-item__graphic">
              <span class="material-icons-outlined navi-icons" :class="{
                'mdc-list-item__active_icon': getCurrentRoute(
                  '/independent/survey'
                ),
              }">find_in_page</span>
            </span>
            <p v-if="this.newSurvey" data-letters="N" />

            {{ $t("S10031") }}
          </router-link>


          <!-- Rubicon -->
          <!-- 250310 jaehyub.lee : 루비콘 스테이지 적용 (루비콘 URL 생성) -->
          <!-- 260629 hide rubicon menu
          <hr class="mdc-list-divider" />
          <div class="mdc-list-item" aria-current="page" @click="handleRubicon">
            <span
              class="drawer-icon-size material-icons-outlined mdc-list-item__graphic t-color-content1"
            >
              smart_toy
            </span>
            {{ $t("S20127") }}
          </div>
          -->

          <hr class="mdc-list-divider" />

          <!-- 나의 활동 - 드로어 -->
          <drawer-activity @closeDrawer="closeDrawer" @handleCategory="handleCategory"
            :openCategory="openCategory"></drawer-activity>

          <hr class="mdc-list-divider" />

          <!-- 설정 -->
          <router-link class="mdc-list-item" :class="[
            routeName[0] === 'setting' ? 'mdc-list-item--activated' : '',
            { 'mdc-list-item__active': getCurrentRoute('/setting') },
          ]" to="/setting" @click.native="activeInactive('setting')" aria-current="page">
            <span class="drawer-icon-size material-icons mdc-list-item__graphic">
              <span class="material-icons navi-icons" :class="{
                'mdc-list-item__active_icon': getCurrentRoute('/setting'),
              }">settings</span>
            </span>
            {{ $t("2050") }}
          </router-link>

          <hr class="mdc-list-divider" />

          <!-- 로그아웃 -->
          <a class="mdc-list-item" @click="logout">
            <span class="drawer-icon-size material-icons mdc-list-item__graphic">
              <span class="material-icons navi-icons">exit_to_app</span>
            </span>
            {{ $t("S10034") }}
          </a>
        </nav>
      </div>
    </aside>

    <div class="mdc-drawer-scrim"></div>

    <div class="mdc-dialog">
      <div class="mdc-dialog__container">
        <div class="mdc-dialog__surface">
          <h2 class="mdc-dialog__title">
            {{ $t("272") }}
            <!-- 프로필 유형 -->
          </h2>
          <div class="mdc-dialog__content">
            <ul class="mdc-list mdc-list--avatar-list">
              <li class="mdc-list-item" tabindex="0">
                <router-link class="text-title" to="/member/profilePicture">
                  <span class="mdc-list-item__text">
                    {{ $t("273") }}
                    <!-- 엘범에서 사진 선택 -->
                  </span>
                </router-link>
              </li>
              <!-- <li class="mdc-list-item">
                                <span class="mdc-list-item__text">
                                    {{$t('274')}}
                                    카메라로 쵤영
                                </span>
              </li>-->
              <li class="mdc-list-item">
                <router-link class="text-title" to="/member/profilePatten">
                  <span class="mdc-list-item__text">
                    {{ $t("275") }}
                    <!-- 패턴으로 등록 -->
                  </span>
                </router-link>
              </li>
            </ul>
          </div>
          <footer class="mdc-dialog__actions">
            <button type="button" class="mdc-button mdc-dialog__button btn-white" data-mdc-dialog-action="no">
              <span class="mdc-button__label">
                {{ $t("276") }}
                <!-- 닫기 -->
              </span>
            </button>
          </footer>
        </div>
      </div>
      <div class="mdc-dialog__scrim"></div>
    </div>
  </section>
</template>

<script>
/**
 * 네비게이션 드로워 회원 컴포넌트(navigation drawer member Components)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import loginApi from "@/api/loginApi.js";
import memberApi from "@/api/memberApi.js";
import mainApi from "@/api/mainApi.js";
import socialApi from "@/api/socialApi.js";

import { moveToRubicon } from "@/utils/rubiconUtil";

import TopAppBarDrawerLanguage from "./TopAppBarDrawerLanguage.vue";
import TopAppBarDrawerLectureList from "./TopAppBarDrawerLectureList.vue";
import TopAppBarDrawerContent from "./TopAppBarDrawerContent.vue";
import TopAppBarDrawerElearning from "./TopAppBarDrawerElearning.vue";
import TopAppBarDrawerSetting from "./TopAppBarDrawerSetting";
import TopAppBarDrawerActivity from "./TopAppBarDrawerActivity";

import ProfileTierName from "./common/ProfileTierName.vue";
import ProfileTier from "./common/ProfileTier.vue";
import { logoutUtil } from "../utils/logoutUtil";

export default {
  props: ["isDrawerOpen", "noForum", "noEvent", "noticeBoardData"],
  components: {
    "drawer-language": TopAppBarDrawerLanguage,
    "drawer-lecture-list": TopAppBarDrawerLectureList,
    "drawer-content": TopAppBarDrawerContent,
    "drawer-e-learning": TopAppBarDrawerElearning,
    "drawer-setting": TopAppBarDrawerSetting,
    "drawer-activity": TopAppBarDrawerActivity,
    ProfileTierName,
    ProfileTier,
  },

  data() {
    return {
      // token: localStorage.getItem('token'),
      hideIcon: "",
      memberData: {},
      memberImageUrl: "",
      memberName: "",
      memberDutyRoleName: "",
      memberResponsibilityName: "",
      newContent: [],
      newDegree: false,
      newSurvey: false,
      newExam: false,
      newEvent: false,
      statusVal: "",
      routeName: [],
      routeQuery: [],

      openCategory: null,

      // forum 게시판 권한 확인
      forumData: null,

      categoryGroup: [],
    };
  },

  beforeMount() {
    // 포럼 게시판 권한 확인
    this.getForumAuth();

    this.routeName = this.$route.path.split("/").slice(1);
    mainApi
      .fetchNew()
      .then((response) => {
        this.newContent = response.data.data;
        // console.log("====== this.newContent", this.newContent);
        this.newContent.map((item) => {
          if (item.gubun == "DEGREE") this.newDegree = true;
          if (item.gubun == "SURVEY") this.newSurvey = true;
          if (item.gubun == "EXAM") this.newExam = true;
          if (item.gubun == "EVENT") this.newEvent = true;
        });
      })
      .catch((err) => {
        let responseData = err.response.data.meta;
        this.$error({ content: responseData.errMsg }).then(() => { });
      });
  },

  mounted() {
    // 회원정보 가져오기(get member information)
    memberApi.getMemberInfo().then((response) => {
      // console.log("getMemberInfo", response.data.data);
      let responseData = response.data.data;
      this.memberData = responseData;
      this.memberImageUrl = responseData.profile;
      // this.memberName = responseData.name.fullName;
      this.memberName = responseData.name.last + " " + responseData.name.first;
      this.memberDutyRoleName = responseData.dutyName;
      this.memberResponsibilityName = responseData.responsibilityName;
      localStorage.setItem(
        "responsibilityName",
        responseData.responsibilityName
      );
    });
    this.handleCategoryRoute(this.$route.fullPath);

    // 카테고리의 그룹
    this.getCategoryGroup();
  },

  $route: function (to, from) {
    this.handleCategoryRoute(to.fullPath);
  },

  methods: {
    async getCategoryGroup() {
      try {
        const response = await mainApi.fetchGroupCategory();
        this.categoryGroup = response.data.data;
      } catch (error) {
        console.error("Error getCategoryGroup > ", error);
      }
    },

    handleCategory(categoryName) {
      this.openCategory = categoryName;
    },
    handleCategoryRoute(url) {
      const isLearn = url.indexOf("learn") !== -1;
      const isContents = url.indexOf("CONTENTS") !== -1;
      const isActivity =
        url.indexOf("myinfo") !== -1 ||
        url.indexOf("leader") !== -1 ||
        url.indexOf("portfolio") !== -1 ||
        url.indexOf("point") !== -1 ||
        url.indexOf("rewardcertificatelist") !== -1 ||
        url.indexOf("rewardbadgelist") !== -1 ||
        url.indexOf("prize-request") !== -1;

      if (isLearn && isContents) {
        return (this.openCategory = "content");
      }

      if (isLearn && !isContents) {
        return (this.openCategory = "elearning");
      }

      if (!isLearn && isActivity) {
        return (this.openCategory = "activity");
      }
    },
    // 프로필 설정 메뉴 오픈(open profile menu)
    openPattenDialog() {
      this.$emit("openPattenDialog");
    },

    closeDrawer() {
      this.$emit("closeDrawer");
    },

    // 로그아웃(logout)
    async logout() {
      await logoutUtil(this);
    },

    showAlert() {
      this.$alert({
        // title: this.$t('72'),
        content: this.$t("73"),
        accept: this.$t("74"),
      });
    },
    activeInactive(val) {
      if (this.statusVal === val) {
        this.hideIcon = false;
        this.statusVal = "";
      } else {
        this.hideIcon = true;
        this.statusVal = val;
      }
      this.routeQuery = this.$route.query;
    },

    getCurrentRoute(item) {
      const isCurrentRoute = item === this.$route.path;
      return isCurrentRoute;
    },

    async handleRubicon() {
      moveToRubicon(this);
      this.closeDrawer();
    },

    hasQueryParams(linkUrl) {
      return /\?.+=/.test(linkUrl);
    },

    async getForumAuth() {
      try {
        const result = await socialApi.bordList({ bid: "sns" });
        this.forumData =
          result.data.data.length === 0 ? null : result.data.data;
      } catch (error) {
        console.log("Get Forum Auth Error : ", error);
      }
    },

    socialLearningRouterLink() {
      let bId =
        !this.forumData ||
          this.forumData.length === 0 ||
          !this.forumData[0].identifier
          ? "sns"
          : this.forumData[0].identifier;
      return `/socialLearning?bId=${bId}`;
    },
  },
};
</script>
<style scoped>
.mdc-list-item {
  color: #818181 !important;
  text-decoration: none !important;
}

.mdc-list-item-active {
  color: #448aff !important;
}

.profile_setting {
  position: absolute;
  width: 32px;
  left: 60px;
  bottom: 4px;
}

.pda-default {
  position: relative;
}

.name-line-height {
  line-height: 1.5em;
}

.mdc-list {
  margin-bottom: 34px;
}

.mdc-list-item__active {
  color: #2d6dcc !important;
}

:not(.mdc-list--non-interactive)> :not(.mdc-list-item--disabled).mdc-list-item::before {
  background: none !important;
}

.mdc-list-item__rubicon__right_icon {
  margin-left: auto;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.material-icon-small-size {
  font-size: 16px !important;
}
</style>
